$(function() {
	const $doc = $(document);

	$doc.on('click', '.accordion_list_item .label_box', onClickAccordionLabelBox);

	initProductPage();
})

/**
 * 商品詳細ページ初期化
 */
function initProductPage() {

}

/**
 * アコーディオン開閉ラベルクリック時処理
 * @param e
 */
function onClickAccordionLabelBox(e) {
	e.preventDefault();

	const isOpen = $(this).hasClass('is_open');

	if (isOpen) {
		// 閉じる
		$(this).removeClass('is_open');
		$(this).next().slideUp(200);
	} else {
		// 開く
		$(this).addClass('is_open');
		$(this).next().slideDown(200);
	}
}